<template>
  <div class="basic_wrap user-page help-page">
    <header class="help-header">
      <button
        type="button"
        class="help-back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('shopds.help') }}</h1>
    </header>
    <section class="help-hero">
      <label class="help-search">
        <van-icon name="search" />
        <input
          v-model.trim="query"
          type="search"
          :placeholder="$t('index.search')"
        >
      </label>
    </section>
    <main class="help-content">
      <div
        v-if="visibleItems.length"
        class="help-list"
      >
        <router-link
          v-for="item in visibleItems"
          :key="item.id"
          :to="'about/' + item.id"
          class="item"
        >
          <span>{{ item['title_' + lang] }}</span>
          <van-icon name="arrow" />
        </router-link>
      </div>
      <van-empty
        v-else-if="loaded"
        :description="$t('orders.noOrders')"
      />
    </main>
  </div>
</template>

<script>
    import Vue from 'vue';
    import { Empty, Icon } from 'vant';
    import Fetch from '../../utils/fetch';

    Vue.use(Empty).use(Icon);

    export default {
        name: 'HelpCenter',
        data() {
            return {
                lang: this.$i18n.locale || 'zh_cn',
                data: {},
                loaded: false,
                query: ''
            };
        },
        computed: {
            visibleItems() {
                const keyword = this.query.toLowerCase();
                return (this.data.list || []).filter((item) => {
                    const title = String(item['title_' + this.lang] || '').toLowerCase();
                    return title.indexOf(keyword) !== -1;
                });
            }
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/index/about').then((response) => {
                    this.data = response.data || {};
                }).finally(() => {
                    this.loaded = true;
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .help-page {
        min-height: 100vh;
        box-sizing: border-box;
        padding-bottom: calc(var(--app-bottom-menu-height) + 16px + env(safe-area-inset-bottom, 0px));
        background: #f5f5f5;
        color: #333;
    }

    .help-header {
        position: relative;
        display: flex;
        height: 50px;
        align-items: center;
        justify-content: center;
        background: #ee4d2d;
        color: #fff;
    }

    .help-header h1 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
    }

    .help-back {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        width: 50px;
        height: 50px;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: 0;
        background: transparent;
        color: #fff;
        font-size: 22px;
    }

    .help-hero { padding: 14px 16px; background: #ee4d2d; }

    .help-search {
        display: flex;
        height: 40px;
        align-items: center;
        gap: 8px;
        box-sizing: border-box;
        padding: 0 12px;
        border-radius: 3px;
        background: #fff;
        color: #999;
        font-size: 18px;
    }

    .help-search input {
        min-width: 0;
        flex: 1;
        border: 0;
        color: #333;
        font-size: 14px;
        line-height: 20px;
    }

    .help-search input::placeholder { color: #9a9a9a; }

    .help-content { padding-top: 10px; }
    .help-list { background: #fff; }

    .item {
        display: flex;
        min-height: 58px;
        align-items: center;
        gap: 12px;
        box-sizing: border-box;
        margin-left: 16px;
        padding: 10px 16px 10px 0;
        border-bottom: 1px solid #ececec;
        color: #333;
        font-size: 14px;
        line-height: 20px;
    }

    .item:last-child { border-bottom: 0; }
    .item span { flex: 1; }
    .item .van-icon { color: #b8b8b8; font-size: 14px; }
    /deep/ .van-empty { background: #fff; }
</style>
